<template>
	<div
		id="offerStatus-detail"
		:class="[!isWeb ? 'mobile-offerStatus-detail' : '', !isWeb && isSafari ? 'safari' : '']"
	>
		<div class="detail-title">
			<div class="detail-title__icon" @click="goToStatus()">
				<SidebarArrow :border="'#0047ff'" />
			</div>
			<h1 class="detail-title__text">
				{{ !$route.query.id ? 'Detalhes do Status da Oferta' : 'Editar Status da Oferta' }}
			</h1>
		</div>
		<OfferStatusForm :isWeb="isWeb" />
	</div>
</template>

<script>
import SidebarArrow from '@/components/shared/Icons/SidebarArrow.vue';
import OfferStatusForm from '@/components/modules/OfferStatus/OfferStatusDetail/OfferStatusForm/OfferStatusForm.vue';

export default {
	name: 'OfferStatusDetail',
	components: { SidebarArrow, OfferStatusForm },
	data: () => ({
		windowWidth: window.innerWidth,
	}),
	created() {},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		goToStatus() {
			this.$router.push({ path: '/dashboard/config/offerStatus' });
		},
	},
	computed: {
		isWeb() {
			return this.windowWidth > 992;
		},
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
};
</script>

<style lang="scss">
@import 'OfferStatusDetail.scss';
</style>
